import axios from 'axios';
import config from '@/config/environment-config';
import store from '@/store';

const shopApiBaseURL = config[process.env.NODE_ENV][environment.region].API,
    getServiceList = (locale) =>
        axios.get(`${shopApiBaseURL}/${locale}/services`).then(({ data }) => {
            store.commit('setUserData', data.user);
            return data.services || [];
        }),
    getCategoryList = (locale, service_group_code) =>
        axios.get(`${shopApiBaseURL}/${locale}/services/${service_group_code}/categories`).then(({ data }) => {
            store.commit('setUserData', data.user);
            return data.categories || [];
        }),
    getItemList = (locale, service_group_code, category_no) =>
        axios
            .get(
                `${shopApiBaseURL}/${locale}/services/${service_group_code}/items${
                    category_no !== 0 ? `?category=${category_no}` : ''
                }`
            )
            .then(({ data }) => {
                store.commit('setUserData', data.user);
                return data.items || [];
            }),
    getItem = (locale, service_group_code, item_no) =>
        axios.get(`${shopApiBaseURL}/${locale}/services/${service_group_code}/items/${item_no}`).then(({ data }) => {
            store.commit('setUserData', data.user);
            return data.items[0] || {};
        }),
    beginTransaction = (locale, item_no, currency, service_group_code, quantity) =>
        axios
            .post(`${shopApiBaseURL}/${locale}/transactions`, {
                no: item_no,
                currency,
                service_group_code,
                quantity,
            })
            .then(({ data }) => data.authorization_url || ''),
    ShopAPI = {
        install(Vue) {
            Vue.prototype.$shopAPI = {
                getServiceList,
                getCategoryList,
                getItemList,
                getItem,
                beginTransaction,
            };
        },
    };

export default ShopAPI;

export { getServiceList, getCategoryList, getItemList, getItem, beginTransaction };
